import client from './client';

export async function getPublicLeaderboard() {
  const response = await client.get('/leaderboard');
  return response.data;
}

export async function getOperatorLeaderboard() {
  const response = await client.get('/operator/leaderboard');
  return response.data;
}
